import React, { FunctionComponent } from 'react'
import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'

import { Box } from '@material-ui/core'

import { BoxLoader } from './BoxLoader'

import { useStore } from '../hooks/storeHook'
import { useAccountParamsOptional } from '../hooks/routeHooks'

import { appRoutes } from '../common/appRoutes'
import { required } from '../common/objectUtils'

import { integrationTypeNames } from '../types/integrationTypeUtils'
import { AccountProps, StoreAccountModel } from '../types/accountProps'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export interface StoreScreenTabsBaseProps<TAccount extends StoreAccountModel> {
  canAddAccount?: boolean

  canRemoveAccount?: boolean,

  ScreenComponent: FunctionComponent<AccountProps<TAccount>>
}

export interface StoreScreenTabsProps<TAccount extends StoreAccountModel>
  extends StoreScreenTabsBaseProps<TAccount> {
  storeType: IntegrationType.Ozon | IntegrationType.Wildberries | IntegrationType.YandexMarket

  storeAccounts: TAccount[]

  makeAccountName: (account: TAccount) => string
}

export const StoreScreenTabs =
  observer(
    <TAccount extends StoreAccountModel>
    ({
       storeType, storeAccounts,
       canAddAccount, ScreenComponent
     }: StoreScreenTabsProps<TAccount>) => {
      const {syncStore: {moySkladAccount}} = useStore()

      const {accountId} = useAccountParamsOptional()

      if (!accountId || accountId <= 0) {
        return <BoxLoader text="Не выбран аккаунт"/>
      }

      if (moySkladAccount == null) {
        return (
          <Box padding={3}>
            Для работы с маркетплейсами добавьте <Link to={appRoutes.MoySklad.settings}>аккаунт МоегоСклада</Link>.
          </Box>
        )
      }

      if (!canAddAccount && storeAccounts.length === 0) {
        return <Box padding={3}>У вас нет аккаунтов {integrationTypeNames[storeType]}.</Box>
      }

      return <ScreenComponent key={accountId} account={required(storeAccounts.find(_ => _.id === accountId))}/>
    })